// @flow

import { getProductProps } from 'Components/widgets/product/Product.mapper';
import { type ProductProps } from 'Components/widgets/product/Product.utils';
import { type ProductsGridDescriptorProps } from 'Client/cms/toolkit/products-grid/productsGrid.resolver';

export function productsMapper(props: ProductsGridDescriptorProps): Array<ProductProps> {
  const { products = [], productIds = [], config, offer = {} } = props;

  return productIds
    .reduce((prev, next) => {
      const product = products.find(({ id }) => next === id);

      if (product) {
        prev.push(product);
      }

      return prev;
    }, [])
    .map(product => {
      return getProductProps({
        config,
        product,
        contextualizeUrl: !!(props.departureDateStart && props.departureDateEnd),
        offerColor: offer.color,
      });
    });
}

export function asyncPropsMapper(
  initialProps: { products: Array<ProductProps> },
  moreProducts: Array<ProductProps>,
): { products: Array<ProductProps> } {
  const { products = [] } = initialProps;

  return { products: [...products, ...moreProducts] };
}
